import {useTimeAgo} from '@vueuse/core';

export function displayTimeStamp(date: Date, localeString: string = 'en-GB'): string {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
  };
  return date.toLocaleString(localeString, options);
}

export function displayTimeString(date: Date, localeString: string = 'en-GB'): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleDateString(localeString, options);
}

export function getRelativeTime(dateString: string | Date): string {
  return useTimeAgo(dateString).value;
}
